$(document).ready(function() {
 $('.owl-after-before').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots:false,
    responsive:{
        0:{
            items:1
        }
    }
});
  });

 
  document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll('.before-after-image-container');

    sliders.forEach(container => {
      const wrapper = container.querySelector('.before-img-wrapper');
      const line = container.querySelector('.divider-line');
      const button = container.querySelector('.divider-button');

      function moveSlider(x) {
        const bounds = container.getBoundingClientRect();
        let position = x - bounds.left;
        if (position < 0) position = 0;
        if (position > bounds.width) position = bounds.width;
        const percentage = (position / bounds.width) * 100;
        wrapper.style.width = percentage + '%';
        line.style.left = percentage + '%';
        button.style.left = percentage + '%';
      }

      function startDrag(e) {
        e.preventDefault();
        document.onmousemove = (event) => moveSlider(event.clientX);
        document.onmouseup = () => {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }

      button.addEventListener('mousedown', startDrag);
      container.addEventListener('touchmove', function(e) {
        moveSlider(e.touches[0].clientX);
      });
    });
  });
 


